import Vue from 'vue';
import { Carousel, Slide } from '@jambonn/vue-concise-carousel';
import '@jambonn/vue-concise-carousel/dist/vue-concise-carousel.css'

Vue.component('carousel', Carousel);
Vue.component('slide', Slide);